import { render, staticRenderFns } from "./FloorStructure.vue?vue&type=template&id=033904a6&scoped=true"
import script from "./FloorStructure.vue?vue&type=script&lang=js"
export * from "./FloorStructure.vue?vue&type=script&lang=js"
import style0 from "./FloorStructure.vue?vue&type=style&index=0&id=033904a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033904a6",
  null
  
)

export default component.exports